// extracted by mini-css-extract-plugin
export default {"editorDetailSection":"editor_detail_editorDetailSection__urqt4"};